//overall
export const SETSAVESTATUS = 'SETSAVESTATUS';
export const CHECKIFPLUGIN = 'CHECKIFPLUGIN';
export const CHECKIFAGENT = 'CHECKIFAGENT';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SETCURRENTUSER = 'SETCURRENTUSER';
export const SELECTEDUSER = 'SELECTEDUSER';
export const SETLANG = 'SETLANG';
export const GOTO = 'GOTO';
export const SHOWALERT = 'SHOWALERT';
export const HIDEALERT = 'HIDEALERT';
export const SHOWLOADER = 'SHOWLOADER';
export const SHOWMODALCOMPONENT = 'SHOWMODALCOMPONENT';
export const HIDEMODALCOMPONENT = 'HIDEMODALCOMPONENT';
export const SHOWMODALSEARCHPARTSCOMPONENT = 'SHOWMODALSEARCHPARTSCOMPONENT';
export const HIDEMODALSEARCHPARTSCOMPONENT = 'HIDEMODALSEARCHPARTSCOMPONENT';
export const SETBUTTONSTATEMODALCOMPONENT = 'SETBUTTONSTATEMODALCOMPONENT';
export const SETALERTCONTAINER = 'SETALERTCONTAINER';
export const SHOWSETTINGS = 'SHOWSETTINGS';
export const HIDESETTINGS = 'HIDESETTINGS';
export const SETALERT = 'SETALERT';
export const GETNOTIFICATIONS = 'GETNOTIFICATIONS';
export const SETROUTING = 'SETROUTING';
export const SETVIEW = 'SETVIEW';
export const SETSECTIONPREFIX = 'SETSECTIONPREFIX';

export const RELOADAFTERDELETETREEITEM = 'RELOADAFTERDELETETREEITEM';

export const SETOUTERDATA = 'SETOUTERDATA';


export const SETFILTEREDDATA = 'SETFILTEREDDATA';

export const SETSECONDLEVEL = 'SETSECONDLEVEL';

export const FORWARDROUTINGDATA = 'FORWARDROUTINGDATA';
export const BACKROUTINGDATA = 'BACKROUTINGDATA';
export const RESETROUTINGDATA = 'RESETROUTINGDATA';
export const SETTABDATA = 'SETTABDATA';

//s - Settings

export const S_CHANGESKINVARIANTS = 'S_CHANGESKINVARIANTS';
export const S_LIC = 'S_LIC';
export const S_GLOBALSETTINGS = 'S_GLOBALSETTINGS';

//U - Users

export const CREATEUSERFORM = 'CREATEUSERFORM';
export const USERSQUANTITY = 'USERSQUANTITY';

//permissions

export const CREATEGROUPFORM = 'CREATEGROUPFORM';
export const SETPERMISSIONGROUP = 'SETPERMISSIONGROUP';
//All
export const GETDATATREE = 'GETDATATREE';
export const SELECTTREEITEM = 'SELECTTREEITEM';
export const SELECTTREEITEMOBJECT = 'SELECTTREEITEMOBJECT';
export const GETDATA = 'GETDATA';
export const GETREVISIONHISTORY = 'GETREVISIONHISTORY';


export const SETAUTHORITYTOCHANGE = 'SETAUTHORITYTOCHANGE';
export const EXTERNALSEARCHRESPONSE = 'EXTERNALSEARCHRESPONSE';
export const SETSELECTEDSEARCHEDROWS = 'SETSELECTEDSEARCHEDROWS';
export const DELETESELECTEDSEARCHEDROWS = 'DELETESELECTEDSEARCHEDROWS';

export const EDITPROPERTIESFORM = 'EDITPROPERTIESFORM';

export const PM_ADDACTIVEFILTER = 'PM_ADDACTIVEFILTER';
export const PM_DELETEACTIVEFILTER = 'PM_DELETEACTIVEFILTER';
export const PM_DELETEALLACTIVEFILTERS = 'PM_DELETEALLACTIVEFILTERS';

export const PM_ADDACTIVEACTION = 'PM_ADDACTIVEACTION';
export const PM_DELETEACTIVEACTION = 'PM_DELETEACTIVEACTION';
export const PM_DELETEALLACTIVEACTIONS = 'PM_DELETEALLACTIVEACTIONS';

export const LM_ADDACTIVEFILTER = 'LM_ADDACTIVEFILTER';
export const LM_DELETEACTIVEFILTER = 'LM_DELETEACTIVEFILTER';
export const LM_DELETEALLACTIVEFILTERS = 'LM_DELETEALLACTIVEFILTERS';

export const LM_ADDACTIVEACTION = 'LM_ADDACTIVEACTION';
export const LM_DELETEACTIVEACTION = 'LM_DELETEACTIVEACTION';
export const LM_DELETEALLACTIVEACTIONS = 'LM_DELETEALLACTIVEACTIONS';

export const SETELEMENTCATEGORY = 'SETELEMENTCATEGORY';

export const SETSELECTEDROWS = 'SETSELECTEDROWS';
export const SETONESELECTEDROWS = 'SETONESELECTEDROWS';
export const DELETESELECTEDROWS = 'DELETESELECTEDROWS';
export const DELETEALLSELECTEDROWS = 'DELETEALLSELECTEDROWS';

export const SETSELECTEDROWSSEARCH = 'SETSELECTEDROWSSEARCH';
export const DELETESELECTEDROWSSEARCH = 'DELETESELECTEDROWSSEARCH';
export const DELETEALLSELECTEDROWSSEARCH = 'DELETEALLSELECTEDROWSSEARCH';


export const GETFILTERS = 'GETFILTERS';
export const GETDETAILS = 'GETDETAILS';
export const GETFORMDETAILS = 'GETFORMDETAILS';
export const ADDPROPERTYTOSAVING = 'ADDPROPERTYTOSAVING';
export const ADDPROPERTYTOSAVINGUL = 'ADDPROPERTYTOSAVINGUL';
export const ADDLIBRARYFILESTOSAVING = 'ADDLIBRARYFILESTOSAVING';
export const RESETPROPERTYTOSAVING = 'RESETPROPERTYTOSAVING';
export const RESETLIBRARYFILESTOSAVING = 'RESETLIBRARYFILESTOSAVING';
export const SETPARTREVISIONID = 'SETPARTREVISIONID';

export const SELECTREVISIONROW = 'SELECTREVISIONROW';
export const DESELECTREVISIONROW = 'DESELECTREVISIONROW';
export const DESELECTALLREVISIONROW = 'DESELECTALLREVISIONROW';

export const SELECTFORMROW = 'SELECTFORMROW';
export const DESELECTFORMROW = 'DESELECTFORMROW';
export const DESELECTALLFORMROW = 'DESELECTALLFORMROW';

export const SETFORMTABLEINSTANCE = 'SETFORMTABLEINSTANCE';

export const SELECTINDEXFORMROW = 'SELECTINDEXFORMROW';
export const DELETEINDEXFORMROW = 'DELETEINDEXFORMROW';

export const SETTERFORMDETAILSDATA = 'SETTERFORMDETAILSDATA';

export const SETFORMPROPERTY = 'SETFORMPROPERTY';
export const CREATEPROPERTYFORM = 'CREATEPROPERTYFORM';

export const ADDSELECTEDFOOTPRINTS= 'ADDSELECTEDFOOTPRINTS';
export const DELETESELECTEDFOOTPRINTS= 'DELETESELECTEDFOOTPRINTS';
export const ADDSELECTEDSYMBOLS = 'ADDSELECTEDSYMBOLS';
export const DELETESELECTEDSYMBOLS = 'DELETESELECTEDSYMBOLS';
export const DELETEALLSELECTEDSYMBOLS = 'DELETEALLSELECTEDSYMBOLS';
export const ADDSELECTEDALTSYMBOLS = 'ADDSELECTEDALTSYMBOLS';
export const DELETESELECTEDALTSYMBOLS = 'DELETESELECTEDALTSYMBOLS';
export const DELETEALLSELECTEDALTSYMBOLS = 'DELETEALLSELECTEDALTSYMBOLS';

export const GETPINSTABLE = 'GETPINSTABLE';
export const GETPINSTABLEDETAILS = 'GETPINSTABLEDETAILS';
export const GETDEPENDONTABLE = 'GETDEPENDONTABLE';
export const GETDEPENDONTABLEDETAILS = 'GETDEPENDONTABLEDETAILS';
export const GETUSEINTABLE = 'GETUSEINTABLE';
export const GETUSEINTABLEDETAILS = 'GETUSEINTABLEDETAILS';
export const GETTASKSTABLE = 'GETTASKSTABLE';
export const EVENTTASKRESPONSE = 'EVENTTASKRESPONSE';

export const GETPOSSIBLEVALUEFORCOMBO = 'GETPOSSIBLEVALUEFORCOMBO';

export const GETSEARCHEDPARTS = 'GETSEARCHEDPARTS';
export const SETSEARCHINGOBJECT = 'SETSEARCHINGOBJECT';

export const GETPROCESSID = 'GETPROCESSID';
export const DELETEPROCESSID = 'DELETEPROCESSID';
export const SETPROCESSID = 'SETPROCESSID';

export const SETEVENTTASKFORM = 'SETEVENTTASKFORM';

// export const GETSYMBOLS = 'GETSYMBOLS';
// export const GETFOOTPRINTS = 'GETFOOTPRINTS';

export const SETCATEGORYMAPPING = 'SETCATEGORYMAPPING';
export const DELETECATEGORYMAPPING = 'DELETECATEGORYMAPPING';

export const SETDERIVEDNEWPROPS = 'SETDERIVEDNEWPROPS';

export const SETCURRENTSYMBOL = 'SETCURRENTSYMBOL';

export const RENAMING = 'RENAMING';
export const MOVING = 'MOVING';
export const DELEGATION = 'DELEGATION';

export const TRANSFEROWNERSHIP = 'TRANSFEROWNERSHIP';

export const SETMODALALERT = 'SETMODALALERT';

//D - Dashboard
export const D_GETDASHBOARDWIDGETS = 'D_GETDASHBOARDWIDGETS';
export const D_GETFILTEREDDATA = 'D_GETFILTEREDDATA';
export const D_SETFILTEREDDATA = 'D_SETFILTEREDDATA';
export const D_SETWIDGETSSETTINGS = 'D_SETWIDGETSSETTINGS';
//PM - PartManager
export const SETPROPERTYID = 'SETPROPERTYID';

export const RELOADAFTERACTIONCOMPLEX = 'RELOADAFTERACTIONCOMPLEX';

export const SETIMPORTEDFILEID = 'SETIMPORTEDFILEID';
export const SETPREVIEWPARTS = 'SETPREVIEWPARTS';
export const RESETMAPFIELD = 'RESETMAPFIELD';
export const ADDMAPFIELD = 'ADDMAPFIELD';

export const ADDALTERNATIVEPART = 'ADDALTERNATIVEPART';
export const DELETEALTERNATIVEPART = 'DELETEALTERNATIVEPART';
export const DELETEALLALTERNATIVEPART = 'DELETEALLALTERNATIVEPART';

export const SELECTALTERNATIVE = 'SELECTALTERNATIVE';
export const UNSELECTALTERNATIVE = 'UNSELECTALTERNATIVE';

export const SETALLACTIVEIMPORTEDPARTS = 'SETALLACTIVEIMPORTEDPARTS';

export const SETNOTIMPORTEDPARTS = 'SETNOTIMPORTEDPARTS';

export const SETDUPLICATEPARTNUMBER = 'SETDUPLICATEPARTNUMBER';

export const SETEXISTINGTYPES = 'SETEXISTINGTYPES';

export const SETNEWSUBCATEGORY = 'SETNEWSUBCATEGORY';

export const CREATENEWASSEMBLYFORM = 'CREATENEWASSEMBLYFORM';

export const SETSELECTEDASSEMBLYROW = 'SETSELECTEDASSEMBLYROW';
export const DELETESELECTEDASSEMBLYROW = 'DELETESELECTEDASSEMBLYROW';
export const SETASSEMBLYQUANTITY = 'SETASSEMBLYQUANTITY';

export const SETTABSTATUS = 'SETTABSTATUS';

export const SELECTPARTSE = 'SELECTPARTSE';

//export const PM_GETDATATREE = 'PM_GETDATATREE';
//export const PM_SELECTTREEITEM = 'PM_SELECTTREEITEM';
//export const PM_getFilters = 'PM_getFilters';


//export const PM_ADDACTIVEFILTER = 'PM_ADDACTIVEFILTER';
//export const PM_DELETEACTIVEFILTER = 'PM_DELETEACTIVEFILTER';

//export const PM_SETPARTCATEGORY = 'PM_SETPARTCATEGORY';
//export const PM_SETSELECTEDROWS = 'PM_SETSELECTEDROWS';
//export const PM_DELETESELECTEDROWS = 'PM_DELETESELECTEDROWS';

//LM - LibraryManager
//export const LM_GETDATATREE = 'LM_GETDATATREE';
//export const LM_SELECTTREEITEM = 'LM_SELECTTREEITEM';
//export const LM_getFilters = 'LM_getFilters';
//export const LM_GETDATA = 'LM_GETDATA';

//export const LM_ADDACTIVEFILTER = 'LM_ADDACTIVEFILTER';
//export const LM_DELETEACTIVEFILTER = 'LM_DELETEACTIVEFILTER';

//export const LM_SETPARTCATEGORY = 'LM_SETPARTCATEGORY';
//export const LM_SETSELECTEDROWS = 'LM_SETSELECTEDROWS';
//export const LM_DELETESELECTEDROWS = 'LM_DELETESELECTEDROWS';

//PM - PartManager

export const P_SHOWPROCESSDIAGRAM = 'P_SHOWPROCESSDIAGRAM';


//LM - LibraryManager
export const SETLIBRARYCATEGORYMAPPING = 'DELETELIBRARYCATEGORYMAPPING';
export const DELETELIBRARYCATEGORYMAPPING = 'DELETELIBRARYCATEGORYMAPPING';

export const GETDATATREELIBRARY = 'GETDATATREELIBRARY';
export const SELECTTREELIBRARYITEM = 'SELECTTREELIBRARYITEM';
export const SELECTTREELIBRARYITEMOBJECT = 'SELECTTREELIBRARYITEMOBJECT';

export const SETELEMENTCATEGORYLIBRARY = 'SETELEMENTCATEGORYLIBRARY';
export const SETLIBSTATUSES = 'SETLIBSTATUSES';
export const SETCSVIMPORT = 'SETCSVIMPORT';

//projm - ProjectManager

export const SETPROJECTCATEGORYMAPPING = 'DELETEPROJECTCATEGORYMAPPING';
export const DELETEPROJECTCATEGORYMAPPING = 'DELETEPROJECTCATEGORYMAPPING';

export const GETDATATREEPROJECT = 'GETDATATREEPROJECT';
export const SELECTTREEPROJECTITEM = 'SELECTTREEPROJECTITEM';
export const SELECTTREEPROJECTITEMOBJECT = 'SELECTTREEPROJECTITEMOBJECT';

export const SETELEMENTCATEGORYPROJECT = 'SETELEMENTCATEGORYPROJECT';

export const CREATEPROJECTFORM = 'CREATEPROJECTFORM';

export const SETSELECTEDPROJECTROW = 'SETSELECTEDPROJECTROW';
export const DELETESELECTEDPROJECTROW = 'DELETESELECTEDPROJECTROW';

export const SETBOMDESCRIPTION = "SETBOMDESCRIPTION";
export const DELETEBOMDESCRIPTION = "DELETEBOMDESCRIPTION";

export const SETSELECTEDPARTBOMROW = "SETSELECTEDPARTBOMROW";
export const DELETESELECTEDPARTBOMROW = "DELETESELECTEDPARTBOMROW";
export const ISBOMINPROJECT = "ISBOMINPROJECT";

export const SETSELECTEDDOCUMENT = "SETSELECTEDDOCUMENT";
export const DELETESELECTEDDOCUMENT = "DELETESELECTEDDOCUMENT";

export const SELECTTREEFOLDERITEMOBJECT = 'SELECTTREEFOLDERITEMOBJECT';

export const CREATESUBFOLDERFORM = 'CREATESUBFOLDERFORM';
export const CREATEVARIANTFOLDERFORM = 'CREATEVARIANTFOLDERFORM';

export const SETSELECTEDBOMROW = 'SETSELECTEDBOMROW';
export const DELETESELECTEDBOMROW = 'DELETESELECTEDBOMROW';

export const SETVARIANTS = 'SETVARIANTS';

export const SETDELEGATEDRESOURCE = 'SETDELEGATEDRESOURCE';
export const ISBOM = "ISBOM";

export const IMPORTBOMTYPEFORM = "IMPORTBOMTYPEFORM";
export const CREATEBOMVARIANTFORM = 'CREATEBOMVARIANTFORM';
export const CREATEBOMPARTOBJECTFORM = 'CREATEBOMPARTOBJECTFORM';

export const SETCHECKBOXVARIANT = 'SETCHECKBOXVARIANT'
export const REMOVECHECKBOXVARIANT = 'REMOVECHECKBOXVARIANT'

export const SETSELECTEDSEARCHPARTROWS = 'SETSELECTEDSEARCHPARTROWS'
export const DELETEALLSELECTEDSEARCHPARTROWS = 'DELETEALLSELECTEDSEARCHPARTROWS'

export const SETIPCIMAGESTATUS = 'SETIPCIMAGESTATUS'

export const SETBOMPROPERTIES = 'SETBOMPROPERTIES'

export const SETPROJECTSPEC = 'SETPROJECTSPEC'

export const RELOADPARTINBOM = 'RELOADPARTINBOM'

export const SETBOMDETAILS = 'SETBOMDETAILS'
export const SETPROJECTDETAILS = 'SETPROJECTDETAILS'

//RM - RequestManager

export const REQUESTCREATEFORM = 'REQUESTCREATEFORM'

export const RM_ADDACTIVEFILTER = 'RM_ADDACTIVEFILTER';
export const RM_DELETEACTIVEFILTER = 'RM_DELETEACTIVEFILTER';
export const RM_DELETEALLACTIVEFILTERS = 'RM_DELETEALLACTIVEFILTERS';

export const RM_ADDACTIVEACTION = 'RM_ADDACTIVEACTION';
export const RM_DELETEACTIVEACTION = 'RM_DELETEACTIVEACTION';
export const RM_DELETEALLACTIVEACTIONS = 'RM_DELETEALLACTIVEACTIONS';

export const ADDREQUESTFILESTOSAVING = 'ADDREQUESTFILESTOSAVING';
export const RESETREQUESTFILESTOSAVING = 'RESETREQUESTFILESTOSAVING';

export const ADDPROPERTYREQUESTTOSAVING = 'ADDPROPERTYREQUESTTOSAVING';
export const RESETPROPERTYREQUESTTOSAVING = 'RESETPROPERTYREQUESTTOSAVING';

export const SETREQUESTSELECTEDROWS = 'SETREQUESTSELECTEDROWS'
export const DELETEREQUESTSELECTEDROWS = 'DELETEREQUESTSELECTEDROWS'
export const DELETEALLREQUESTSELECTEDROWS = 'DELETEALLREQUESTSELECTEDROWS'
export const SELECTASSIGNUSER = 'SELECTASSIGNUSER'
export const SETREQUESTDETAILS = 'SETREQUESTDETAILS'
export const SETREQUESTTASKOBJECT = 'SETREQUESTTASKOBJECT'



// WEBPACK FOOTER //
// ./src/store/types.js